/**
 * Checks if the current browser is managed by Playwright, meaning we're in an end-to-end test.
 */
export function isPlaywrightInstance(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.startsWith('playwright')
}
